import { useEffect } from "react";
import { Quote } from "../../../api/Quote/Quote";
import { Box, makeStyles, Theme } from "@material-ui/core";
import { colors } from "../../../components/typography/TF";

const QuoteTopPriceOptions = ({ quote, textAlign }: Props) => {
  const classes = useStyles();
  const url = `https://d3v2ir16k1una.cloudfront.net/content/scripts/flexifi-widget.js?id=0010Y00001Tl4JMQAZ&productPrice=${quote.price}&term=36`;
  return (
    <>
      <Box display="flex" textAlign={textAlign} justifyContent={textAlign === "center" ? "center" : undefined}>
        <div id="flexify-id" className={classes.root}></div>
        <Script src={url} position="#flexify-id" async={false} />
      </Box>
    </>
  );
};

export default QuoteTopPriceOptions;

interface Props {
  quote: Quote;
  textAlign?: string | undefined;
}

const useScript = (url: string, position: string, async: boolean) => {
  useEffect(() => {
    const placement = document.querySelector(position);
    const script = document.createElement("script");

    script.src = url;
    script.async = typeof async === "undefined" ? true : async;

    placement?.appendChild(script);

    return () => {
      while (placement?.firstChild) {
        placement.removeChild(placement.firstChild);
      }
    };
  }, [url, position, async]);
};

export const Script = ({ src = "", position = "", async = true }) => {
  useScript(src, position, async);

  return null;
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    "& .flexifi-widget .flexifi-description": {
      fontSize: "14px",
      color: colors.storeGrey,
      fontWeight: "bold"
    },
    "& a": {
      [theme.breakpoints.down("md")]: {
        textAlign: "center"
      }
    }
  }
}));
